import { useQuery } from '@tanstack/react-query';
import { useHybridAuth } from '../../hooks/useHybridAuth';
import { useDriverStateV2 } from '../../hooks/useDriverStateV2';
import type { ListParams, TruckSortBy } from '@relay-towing/api';
import { getList } from '../list';

export interface Truck {
  id: string;
  truckNumber: string;
  licensePlate: string;
  towRating: number | null;
  currentDriverId: string | null;
  currentDriver?: {
    name: string;
  };
}

export const useGetTrucks = (
  page: number = 1,
  limit: number = 100,
  search: string = '',
  fetchEnabled: boolean = true
) => {
  const { getAccessTokenSilently } = useHybridAuth();
  const { driver } = useDriverStateV2();

  return useQuery({
    queryKey: ['trucks', driver?.companyId, page, limit, search],
    queryFn: async () => {
      if (!driver?.companyId) {
        throw new Error('Company ID not available');
      }

      const token = await getAccessTokenSilently();
      const params = {
        pageNo: page,
        pageSize: limit,
        search: search || undefined,
      } satisfies ListParams<TruckSortBy> & { search?: string };

      return getList<Truck>('/trucks', params, {
        token,
        companyId: driver.companyId,
      });
    },
    enabled: !!driver?.companyId && fetchEnabled,
    staleTime: 30 * 1000, // 30 seconds
  });
};
